export const EVENT_BUS = {
  LESSON_ITEM_MENU_TOGGLE: 'LESSON_ITEM_MENU_TOGGLE',
  SHOW_CREATE_LINK_MODAL: 'SHOW_CREATE_LINK_MODAL',
  SHOW_CREATE_VIDEO_MODAL: 'SHOW_CREATE_VIDEO_MODAL',
  EMIT_TOGGLE_RESUME: 'EMIT_TOGGLE_RESUME',
  ON_TOGGLE_RESUME: 'ON_TOGGLE_RESUME',
  LOAD_LESSON_ON_VIEWER: 'LOAD_LESSON_ON_VIEWER',
  OBJECT_ITEM_SELECTED: 'OBJECT_ITEM_SELECTED',
  OBJECT_ITEM_OPENED: 'OBJECT_ITEM_OPENED',
  GO_TO_DASHBOARD: 'GO_TO_DASHBOARD',
  SAVE_CREATE_MODAL: 'SAVE_CREATE_MODAL',
  RESPONSE_HOMEWORK_MODAL: 'RESPONSE_HOMEWORK_MODAL',
  LOAD_HOMEWORKS_STUDENT: 'LOAD_HOMEWORKS_STUDENT',
  CREATE_OBJECT_FILE: 'CREATE_OBJECT_FILE',
  CREATE_OBJECT_NO_FILE: 'CREATE_OBJECT_NO_FILE',
  LOAD_MODAL_VIEWER_RESPONSE: 'LOAD_MODAL_VIEWER_RESPONSE'
};

export const MY_CONTENT_EVENTS = {
  REMOVE_CONTENT: 'REMOVE_CONTENT',
  ACTION_IN_PROCESS: 'ACTION_IN_PROCESS',
  VIEW_CONTENT: 'VIEW_CONTENT',
  EDIT_CONTENT_INSIDE: 'EDIT_CONTENT_INSIDE',
  EDIT_CONTENT: 'EDIT_CONTENT',
  SEE_MORE_CONTENT: 'SEE_MORE_CONTENT',
  DOWNLOAD_CONTENT: 'DOWNLOAD_CONTENT',
  RELOAD_MENU: 'RELOAD_MENU',
}

export const COURSE_EVENTS = {
  SECTION_OPENED: 'SECTION_OPENED',
  SECTION_SELECTED: 'SECTION_SELECTED',
  EDIT_SECTION: 'EDIT_SECTION',
  REMOVE_SECTION: 'REMOVE_SECTION',
  OBJECT_SELECTED: 'OBJECT_SELECTED',
  EDIT_OBJECT: 'EDIT_OBJECT',
  REMOVE_OBJECT: 'REMOVE_OBJECT',
  ADD_SECTION: 'ADD_SECTION',
  SECTION_CLOSED: 'SECTION_CLOSED',
  LOAD_SECTION_ON_VIEWER: 'LOAD_SECTION_ON_VIEWER',
  LOAD_MATERIAL_ON_VIEWER: 'LOAD_MATERIAL_ON_VIEWER',
  GO_TO_EDIT_SECTION_CONTENT: 'GO_TO_EDIT_SECTION_CONTENT',
  SECTION_REMOVED: 'SECTION_REMOVED',
  SECTION_MOVED: 'SECTION_MOVED',
  SET_OBJECT_FULL_SCREEN: 'SET_OBJECT_FULL_SCREEN',
  LOAD_OBJECT_ON_PREVIEW: 'LOAD_OBJECT_ON_PREVIEW',
  ADD_COURSE_MATERIAL: 'ADD_COURSE_MATERIAL',
  SECTION_MATERIAL_SELECTED: 'SECTION_MATERIAL_SELECTED',
  REFRESH_COURSE_MATERIALS: 'REFRESH_COURSE_MATERIALS',
  REMOVE_SECTION_MATERIAL: 'REMOVE_SECTION_MATERIAL',
  REMOVE_COURSE_MATERIAL_OBJECT: 'REMOVE_COURSE_MATERIAL_OBJECT',
  ADD_COURSE_MATERIAL_OBJECT: 'ADD_COURSE_MATERIAL_OBJECT',
  VIEW_COURSE_MATERIAL_OBJECT: 'VIEW_COURSE_MATERIAL_OBJECT',
  REMOVE_COURSE_MATERIAL_AND_OBJECT: 'REMOVE_COURSE_MATERIAL_AND_OBJECT',
  RENDER_COMPONENT: 'RENDER_COMPONENT',
  SET_ONLY_VISIBLE_FOR_TEACHER_MATERIAL: 'SET_ONLY_VISIBLE_FOR_TEACHER_MATERIAL',
  CHANGE_PARENT_WILL_UPDATE:'CHANGE_PARENT_WILL_UPDATE',
  LOAD_PRESENTATION_COURSE_SECTION: 'LOAD_PRESENTATION_COURSE_SECTION',
  SEND_PRESENTATION_LAYOUT: 'SEND_PRESENTATION_LAYOUT',
  CHANGE_STATE_VIDEO: 'CHANGE_STATE_VIDEO',
  UPDATE_STATE_VIDEO: 'UPDATE_STATE_VIDEO',
  CHANGE_RESIZE: 'CHANGE_RESIZE',
  CHANGE_PDF_ZOOM: 'CHANGE_PDF_ZOOM',
  SEND_TRANSPARENT_WHITEBOARD: 'SEND_TRANSPARENT_WHITEBOARD',
  CHANGE_MULTIMEDIA_STATE: 'CHANGE_MULTIMEDIA_STATE',
  UPDATE_AUDIO_STATE: 'UPDATE_AUDIO_STATE',
  UPDATE_MULTIMEDIA_VIDEO_STATE: 'UPDATE_MULTIMEDIA_VIDEO_STATE',
  REMOVE_PROJECT: 'REMOVE_PROJECT',
  EDIT_PROJECT: 'EDIT_PROJECT',
  PROJECT_OPENED: 'PROJECT_OPENED',
  ADD_OBJECT_PROJECT: 'ADD_OBJECT_PROJECT',
  REMOVE_OBJECT_PROJECT: 'REMOVE_OBJECT_PROJECT',
  SET_OBJECT_PROJECTS: 'SET_OBJECT_PROJECTS',
  SEND_SHARE_TASK: 'SEND_SHARE_TASK',
  SEND_TEXT_CHANGED: 'SEND_TEXT_CHANGED',
  TEXT_CHANGED: 'TEXT_CHANGED',
  CHANGE_ZOOM_VALUE: 'CHANGE_ZOOM_VALUE',
  IS_PDF_LOADING_TRANSPARENCY: 'IS_PDF_LOADING_TRANSPARENCY_documentHash',
  CHANGE_SLIDE: 'CHANGE_SLIDE',
  MOVE_SLIDE: 'MOVE_SLIDE',
  CHANGE_CARD: 'CHANGE_CARD',
  CHANGE_CARD_SIDE: 'CHANGE_CARD_SIDE',
  CARD_CREATED: 'CARD_CREATED',
  FORCE_SEND_SCROLL: 'FORCE_SEND_SCROLL'
}

export const MEETINGS_EVENTS = {
  GO_TO_MEETING_DETAIL: 'GO_TO_MEETING_DETAIL',
  SHOW_MEETING_DETAIL: 'SHOW_MEETING_DETAIL',
  GO_TO_EDIT_MEETING: 'GO_TO_EDIT_MEETING'
}

export const ED_DROPZONE_EVENTS = {
  UPLOAD_FILE: 'UPLOAD_FILE'
}

export const CALENDAR_EVENTS = {
  REMOVE_ITEM: 'REMOVE_ITEM',
  CREATE_ITEM: 'CREATE_ITEM',
  UPDATE_ITEM: 'UPDATE_ITEM'
}
